import { apiClient } from '../../../shared/lib/apiClient';

/**
 * SWRN-1033 — the prediction list is a static, publicly-served asset under
 * public/predictions/<lang>.json (generated from scripts/predictions.<lang>.txt).
 * Fetched via apiClient (baseURL '/') like the other root-relative assets in
 * this module (see order.api.ts → '/dev/qr.json').
 */
const PREDICTIONS_ASSET = (lang: string): string => `/predictions/${lang}.json`;

export const PREDICTION_QUERY_KEYS = {
    all: () => ['predictions'] as const,
    lang: (lang: string) => [...PREDICTION_QUERY_KEYS.all(), lang] as const,
};

export const getPredictions = async (lang = 'uk'): Promise<string[]> => {
    const { data } = await apiClient.get<string[]>(PREDICTIONS_ASSET(lang));
    return data;
};
